// Only an explicit, single webApp=1 opts a business page into browser login.
export function isWebAppQuery(query) { return query.webApp === '1' }

export function isWebEntry(path) { return path === '/login' || path.startsWith('/web/') }

// os is legacy native platform metadata, not a browser-session discriminator.
export function platformFromQuery(query, previous = '') {
  if (!Object.prototype.hasOwnProperty.call(query, 'os')) return previous
  return typeof query.os === 'string' && /^(android|ios)$/i.test(query.os) ? query.os.toLowerCase() : ''
}

export function ownApi(config = {}) {
  try {
    const base = new URL(config.baseURL || '/', window.location.origin)
    const url = new URL(config.url, base)
    return url.origin === window.location.origin && url.pathname.startsWith('/api/')
  } catch (_) { return false }
}

export function ambiguousSessionResponse(data) {
  return data === 1 || data === '1' || (typeof data === 'string' && /<(?:!doctype\s+html|html|body)\b/i.test(data))
}

export function validProfile(data) {
  return !!data && typeof data === 'object' && !Array.isArray(data) && data.id != null && String(data.id).trim() !== '' && String(data.id) !== 'null'
}

export function parseLoginResult(raw) {
  // The legacy endpoint returns a quoted "level-permissions" value, not a token.
  const text = String(raw).trim()
  const quoted = text.match(/"([^"\r\n]*)"/)
  const value = quoted ? quoted[1] : text
  if (value === '0') throw new Error('账号或密码错误，请重新输入')
  const match = value.match(/^([12])(?:-(.*))?$/)
  if (!match) throw new Error('登录响应异常，请稍后重试')
  return { level: Number(match[1]), permissions: match[2] || '' }
}
